<template>
  <b-modal
    v-model="showModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <h5 class="text-info">{{ $t("globals.select_inquiry") }}:</h5>
          <b-form-group>
            <b-form-radio-group
              v-model="selectedInquiryGroup"
              :options="inquiryOptions"
              stacked
            >
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div>
        <hr />
        <b-row v-if="getUserSystem() == 'ULU' || getUserSystem() == 'iMoto'">
          <b-col>
            <b-form-checkbox-group
              v-model="selectedSettings"
              :options="selectedSettingsOptions"
            />
          </b-col>
        </b-row>
      </div>
      <hr />
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="makeOrder()"
            variant="success"
            :disabled="selectedInquiryGroup === null"
          >
            {{ $t("globals.confirm") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="setShowConfirmModal(false)"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    makeOrder: Function,
    showModal: Boolean,
    setSelectedInquiryGroup: Function,
    setShowConfirmModal: Function,
    setSettings: Function,
    inquiryOptions: Array
  },
  data() {
    return {
      selectedInquiryGroup: null,
      selectedSettings: [],
      selectedSettingsOptions: [
        {
          text: "Reverse VAT charge",
          value: {
            key: "reverse_vat",
            value: "true"
          }
        }
      ]
    };
  },
  methods: {
    ...mapGetters(["getUserSystem", "getUserBrandPermissions"])
  },
  watch: {
    selectedInquiryGroup: function() {
      this.setSelectedInquiryGroup(this.selectedInquiryGroup);
    },
    selectedSettings: function() {
      this.setSettings(this.selectedSettings);
    }
  }
};
</script>
